import React from 'react';
import PropTypes from 'prop-types';

import { propertyArea, propertyType } from 'helpers/FormattedSpecifications';
import { translate } from 'helpers/Translate';
import { getHabitationValuationUrl } from 'helpers/Estima';

const HabitationShortcut = ({ habitations }) => {
    if (!habitations || habitations.length === 0) {
        return null;
    }

    const isMultiple = habitations.length !== 1;
    let content = null;

    if (habitations.length === 1) {
        const habitation = habitations[0];

        content = (
            <span className="habitation-shortcut__content">
                {translate('Vous avez déjà estimé un ')}
                <strong>{propertyType(habitation.item_type.key).toLowerCase()}</strong>
                {translate(' de ')}
                <strong>{propertyArea(habitation.area)}</strong>
                {translate(' au ')}
                <strong>{habitation.address.name}</strong>
            </span>
        );
    } else {
        content = (
            <span className="habitation-shortcut__content">
                {translate('Vous avez déjà estimé ')}
                <strong>{habitations.length}</strong>
                {translate(' biens à cette adresse')}
            </span>
        );
    }

    return (
        <div className="estima-form__panel habitation-shortcut">
            <span className="icon-room habitation-shortcut__icon margin-right-double" />
            {content}
            <span className="habitation-shortcut__link">
                <a
                    className="btn btn--secondary btn--small"
                    href={getHabitationValuationUrl(!isMultiple ? String(habitations[0].id) : '')}
                >
                    {translate(isMultiple ? 'Voir toutes mes estimations' : "Voir l'estimation")}
                </a>
            </span>
        </div>
    );
};

HabitationShortcut.displayName = 'HabitationShortcut';

HabitationShortcut.propTypes = {
    habitations: PropTypes.arrayOf(PropTypes.shape({})),
};

/**
 * HabitationShortcut Functional Component.
 */
export default HabitationShortcut;
